import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import CommunityAbout from "../Posts/layouts/CommunityAbout";
import CommunityTopBar from "../Posts/layouts/CommunityTopBar";
import OrganizationUserAbout from "./OrganizationUserAbout";
import { Tab, Tabs } from "react-bootstrap";
import UpcomingEvents from "./UpcomingEvents";
import Discussions from "./Discussions";
import { getOrganizationCommunities } from "../../services/apiOragnizations";


const OrganizationUserView = () => {
  const { slug } = useParams(); 
  const userData = JSON.parse(localStorage.getItem('userData'));
  const communityDetails = JSON.parse(localStorage.getItem('communityData'));
  const [communities, setCommunities] = useState([]);
  const organizationid=communityDetails?._id;
  const [activeTab, setActiveTab] = useState(localStorage.getItem('organizationViewTab') ? localStorage.getItem('organizationViewTab') :"Discussion");

  useEffect (() =>{
    FetchOrganizationCommunities();
  },[slug])

  const FetchOrganizationCommunities = async () => {
    const formData = {
      organizationid : organizationid
    }
      let listCommunities = await getOrganizationCommunities(formData);      
      setCommunities(listCommunities?.communities || []);
    };
  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
     localStorage.setItem("organizationViewTab",(eventKey));
  };
  return (

    <div >
        <CommunityTopBar type="organization"/> 
      <div className="community-features main ml-0  user-view-org">
        <div className="contents ml-0">
       <Tabs /* defaultActiveKey="Discussion" */  activeKey={activeTab}  id="fill-tab-example" className="mt-5 profile_tabs" fill  onSelect={handleTabSelect} >

            <Tab eventKey="Discussion" className="profile-tab-contents mt-4" title="Discussion"> 
              <Discussions organizationid={organizationid}></Discussions>  
             
            </Tab>
            <Tab eventKey="UpcomingEvents" className="profile-tab-contents mt-4" title="Events">
               <UpcomingEvents path="OrganizationUserView" orgSlug={slug}/> 
            </Tab>
          </Tabs>
       </div>
        <OrganizationUserAbout details={communityDetails} community={communities}/>
      </div> 
      </div>

  );

};
export default OrganizationUserView;